const DateFormater = (date) => {
  let outPutDate = "";
  const dbDate = new Date(date);
  // console.log("dbDate", dbDate, date);

  dbDate.setHours(0, 0, 0, 0);
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);

  const differenceInTime = dbDate.getTime() - currentDate.getTime();
  const differenceInDays = differenceInTime / (1000 * 60 * 60 * 24); // convert to days

  if (dbDate.toString() === "Invalid Date") {
    outPutDate = dbDate.toString();
  } else {
    if (differenceInDays === 1) {
      outPutDate = "Invalid Date";
    } else if (differenceInDays === -1) {
      outPutDate = "Yesterday";
    } else if (differenceInDays === 0) {
      outPutDate = "Today";
    } else {
      outPutDate =
        "On " +
        (dbDate.getDate() < 10 ? "0" + dbDate.getDate() : dbDate.getDay()) +
        " " +
        dbDate.toLocaleString("default", { month: "long" });
    }
  }

  return outPutDate;
};

export default DateFormater;
